import { useEffect, useState } from "react";

type Props = {
  src: string;
  className?: string;
  circleCssPoints?: string[] | null | undefined;
  no?: string;
};

export const PartsImage = ({ src, className, circleCssPoints, no }: Props) => {
  const [dimensions, setDimensions] = useState<{
    height: number;
    width: number;
  }>({ height: 0, width: 0 });

  const [imageNaturalDimensions, setImageNaturalDimensions] = useState<{
    height: number;
    width: number;
  }>({ height: 0, width: 0 });

  const [circleMargins, setCircleMargins] = useState<{ left: number; bottom: number }[]>([]);

  useEffect(() => {
    try {
      if (
        dimensions &&
        dimensions.height > 0 &&
        dimensions.width > 0 &&
        imageNaturalDimensions &&
        imageNaturalDimensions.height > 0 &&
        imageNaturalDimensions.width > 0 &&
        circleCssPoints &&
        circleCssPoints.length > 0
      ) {
        const objectCssPositions = circleCssPoints.map((p) => {
          const res = p
            .split(";")
            .map((item) => {
              const tokens = item.trim().split(":");

              if (!tokens || tokens.length < 2) {
                return null;
              }

              const value = tokens[1].replaceAll(";", "");
              return {
                [tokens[0]]: value.trim(),
              };
            })
            .filter((item) => item !== null);

          const bottom = res[0]?.bottom;
          const left = res[1]?.left;

          const leftInt = parseInt(left.split("px")[0]);
          const bottomInt = parseInt(bottom.split("px")[0]);

          const normalizeLeft = (leftInt / imageNaturalDimensions.width) * dimensions.width;
          const normalizeBottom = (bottomInt / imageNaturalDimensions.height) * dimensions.height;

          return { left: normalizeLeft, bottom: normalizeBottom };
        });

        setCircleMargins(objectCssPositions);
      } else {
        setCircleMargins([]);
      }
    } catch (error) {
      // ignore
      setCircleMargins([]);
    }
  }, [circleCssPoints, dimensions, imageNaturalDimensions]);

  return (
    <div className={`relative ${className}`}>
      <img
        alt=""
        src={src}
        onLoad={(e) => {
          const naturalHeight = e.currentTarget.naturalHeight;
          const naturalWidth = e.currentTarget.naturalWidth;
          setImageNaturalDimensions({ height: naturalHeight, width: naturalWidth });
        }}
        ref={(ref) => {
          setTimeout(() => {
            if (ref) {
              setDimensions({ height: ref.offsetHeight, width: ref.offsetWidth });
            }
          }, 1000);
        }}
      />

      {circleMargins.map((circleMargin, index) => {
        return <Circle key={index} no={no} leftMargin={circleMargin.left} bottomMargin={circleMargin.bottom} />;
      })}
    </div>
  );
};

const Circle = ({ leftMargin, bottomMargin, no }: { no?: string; leftMargin: number; bottomMargin: number }) => {
  if (leftMargin === 0 && bottomMargin === 0) {
    return null;
  }

  return (
    <div
      className={`absolute w-6 h-6 bg-white border-2 border-[red] rounded-full flex justify-center align-center`}
      style={{ left: leftMargin, bottom: bottomMargin }}
    >
      <span className="text-md font-bold">{no}</span>
    </div>
  );
};
